(function($) {
    
   

    /*****************************************************************
     * Option
     *****************************************************************/
    function Option(el, wSelect) {
        this.$el = $(el);
        this.wSelect = wSelect;
    }

    Option.prototype = {
        generate: function() {
            var _self = this;
            if (!this.$option) {
                var icon = this.$el.attr('data-icon');

                this.$option = $('<div class="wSelect-option"></div>');
                this.$value = $('<div class="wSelect-option-value"></div>');
                this.$option.append(this.$value);

                if (typeof icon === 'string') {
                    this.$value.addClass('wSelect-option-icon');
                    this.$value.css('backgroundImage', 'url(' + icon + ')');
                }
            }

            if (this.$el.prop('selected')) {
                this.select();
            }

            if (this.$el.prop('disabled')) {
                this.$option.addClass('wSelect-option-disabled');
            }
            else {
                this.$option.removeClass('wSelect-option-disabled');
                this.$option.unbind('click').click(function(e){ _self.onClick(e); });
            }
            
            this.$value.html(this.$el.html()); // in case html has changed we always set it here
            this.setWidth();

            return this.$option;
        },

        select: function() {
            if (!this.wSelect.activeOpt) {
                this.wSelect.activeOpt = this;
            }

            if (!this.wSelect.multiple) {
                var icon = this.$el.attr('data-icon');

                if (typeof icon === 'string') {
                    this.wSelect.$selected.addClass('wSelect-option-icon');
                    this.wSelect.$selected.css('backgroundImage', 'url(' + icon + ')');
                }
                else {
                    this.wSelect.$selected.removeClass('wSelect-option-icon');
                    this.wSelect.$selected.css('backgroundImage', '');
                }

                //if(!this.wSelect.focus) { this.wSelect.$optionsHolder.hide(); }
                this.wSelect.$selected.html(this.$el.html());
            }

            this.$option.addClass('wSelect-option-selected');
        },

        onClick: function(e) {
            var selVal = null;

            if (this.wSelect.multiple && (e.ctrlKey || e.shiftKey) ) {
                if (e.ctrlKey || !this.wSelect.activeOpt) {
                    selVal = this.wSelect.$el.val() || [];

                    var optVal = this.$el.val(),
                        arrayPos = $.inArray(optVal, selVal);

                    if (arrayPos === -1) {
                        selVal.push(this.$el.val());
                        this.wSelect.activeOpt = this; // only set active when "selecting"
                    }
                    else {
                        selVal.splice(arrayPos, 1);
                    }
                }
                // don't set active here as the shift+click only highlights from active option
                else if (e.shiftKey) {
                    var indexActive = this.wSelect.activeOpt.$el.index(),
                        indexCurrent = this.$el.index(),
                        indexStart = 0,
                        indexEnd = 0,
                        $option = null;

                    if (indexCurrent > indexActive) {
                        indexStart = indexActive;
                        indexEnd = indexCurrent;
                    } else {
                        indexStart = indexCurrent;
                        indexEnd = indexActive;
                    }

                    selVal = [];

                    for (var i=indexStart; i<=indexEnd; i++) {
                        $option = this.wSelect.$el.children(':eq(' + i + ')');
                        if ($option.is(':not(:disabled)')) {
                            selVal.push($option.val());
                        }
                    }
                }
            }
            else {
                selVal =  this.$el.val();
                this.wSelect.$optionsHolder.hide();
                this.wSelect.activeOpt = this;
            }

            this.wSelect.$el.val(selVal).change();
        },

        // help us set the proper widths based on given values (this way so we can add options on the fly one at a time)
        setWidth: function() {
            if (this.wSelect.multiple || this.wSelect.widthSet) { return true; }

            this.$option.hide().appendTo('body');
            var optionWidth = this.$option.width();

            if (optionWidth > this.wSelect.$select.width()) {
                this.wSelect.$select.width(optionWidth);
            }
            
            this.$option.detach().show();
        }
    };

    /*****************************************************************
     * fn.wSelect
     *****************************************************************/
    $.support.placeholder = 'placeholder' in document.createElement('input');

    $.fn.wSelect = function(options, value) {
        if (typeof options === 'string') {
            var values = [];
            var elements = this.each(function() {
                var wSelect = $(this).data('wSelect');

                if (wSelect) {
                    var func = (value ? 'set' : 'get') + options.charAt(0).toUpperCase() + options.substring(1).toLowerCase();

                    if (wSelect[options]) {
                        wSelect[options].apply(wSelect, [value]);
                    } else if (value) {
                        if (wSelect[func]) { wSelect[func].apply(wSelect, [value]); }
                        if (wSelect.options[options]) { wSelect.options[options] = value; }
                    } else {
                        if(wSelect[func]) { values.push(wSelect[func].apply(wSelect, [value])); }
                        else if (wSelect.options[options]) { values.push(wSelect.options[options]); }
                        else { values.push(null); }
                    }
                }
            });

            if (values.length === 1) { return values[0]; }
            else if (values.length > 0) { return values; }
            else { return elements; }
        }

        options = $.extend({}, $.fn.wSelect.defaults, options);

        function get(el) {
            var wSelect = $.data(el, 'wSelect');
            if (!wSelect) {
                var _options = jQuery.extend(true, {}, options);
                _options.size = $(el).prop('size') || _options.size;

                wSelect = new Select(el, _options);
                $.data(el, 'wSelect', wSelect);
            }

            return wSelect;
        }

        return this.each(function() { get(this); });
    };
    
    $.fn.wSelect.defaults = {
        theme: 'classic',         // theme
        size: '4',                // default number of options to display (overwrite with `size` attr on `select` element)
        highlight: true           // highlight fields when selected
    };
    
})(jQuery);
